import {environment} from "environments";

class GpLetters {
  constructor($state) {
    Object.assign(this, {
      activeTab: 0,
      tabs: [
        { heading: 'Unverified Addresses', uiSref: 'gpLetters.unverified_addresses' },
        { heading: 'Incomplete Addresses', uiSref: 'gpLetters.incomplete_addresses' },
        { heading: 'Unresponsive Patients', uiSref: 'gpLetters.unresponsive_patients' },
        { heading: 'Pending GP Letters', uiSref: 'gpLetters.pending_letters' },
      ],
    });
    this.tabs = this.tabs.filter(tab => !tab.BOD_103 || tab.BOD_103.includes(environment.constants.ENV))
    this.activeTab = this.tabs.findIndex(({ uiSref }) => $state.current.name === uiSref);
  }
}

GpLetters.$inject = ['$state'];
angular.module('pims').controller('GpLetters', GpLetters);
